export default __webpack_public_path__ + "static/media/logo_ailleclinic.80f606b7.svg";